import React from "react";
import { cn } from "@/lib/utils";

export interface CapacityTileProps {
  label: string;
  value: React.ReactNode;
  hint?: React.ReactNode;
  bar?: {
    percent: number | null;
    className?: string;
  };
  className?: string;
}

export const CapacityTile: React.FC<CapacityTileProps> = ({
  label,
  value,
  hint,
  bar,
  className,
}) => {
  const percent =
    bar && bar.percent !== null
      ? Math.max(0, Math.min(100, bar.percent))
      : null;

  return (
    <div
      className={cn(
        "flex flex-col gap-1.5 rounded-lg border border-base-border bg-background p-4",
        className,
      )}
    >
      <span className="text-xs uppercase tracking-wide text-muted-foreground">
        {label}
      </span>
      <span className="text-2xl font-semibold text-foreground">{value}</span>
      {hint ? (
        <span className="text-xs text-muted-foreground">{hint}</span>
      ) : null}
      {bar ? (
        <div className="mt-2 h-1.5 w-full rounded-full bg-secondary-badge overflow-hidden">
          {percent === null ? null : (
            <div
              className={cn("h-full bg-skyline-2", bar.className)}
              style={{ width: `${percent}%` }}
            />
          )}
        </div>
      ) : null}
    </div>
  );
};
